// extracted by mini-css-extract-plugin
module.exports = {"efmodal":"CouponModal_efmodal__f8z9l"};